<script setup lang="ts">
import { computed } from "vue"

import TextBlockIt from "@/views/main/ForAuthorsView/textBlockIt.vue"
import TextBlockEn from "@/views/main/ForAuthorsView/textBlockEn.vue"

import { generateAbsoluteLink } from "@/lib/utils.ts"

const selectedLanguage = I18n.locale

const guidelinesLink = computed(() => {
  if (selectedLanguage === "en") {
    return generateAbsoluteLink('files/Editorial_Rules_2022.pdf')
  }

  return generateAbsoluteLink('files/Nuove_norme_2022.pdf')
})
</script>

<template>
  <div class="container">
    <h2 class="title">{{ $t("for_authors.title") }}</h2>

    <text-block-en v-if="selectedLanguage === 'en'" />
    <text-block-it v-else />

    <a :href="guidelinesLink" class="classic-link" target="_blank">
      {{ $t("for_authors.download_guidelines") }}
    </a>

    <a :href="`${ generateAbsoluteLink('files/list_of_abbreviations_bilingual.pdf') }`" class="classic-link ml-4" target="_blank">
      {{ $t("for_authors.abbreviation_list") }}
    </a>
  </div>
</template>
